export default "__VITE_ASSET__BKWrtWzd__"